<div class="card card-action" [class.closed]="!isExpanded" [draggable]="!isExpanded">
  <div class="card-menu-header" (click)="$event.preventDefault(); $event.stopPropagation(); isExpanded = !isExpanded">
    <div class="row">
      <div class="col-6 d-md-block vertical-middle consent-name">
        <span class="edit-container">
          <span>{{ consent.id ? consent.name : ('Consent.New_Consent' | trans) }}</span>
        </span>
      </div>

      <div class="col-2 d-none d-md-block">
        <div class="f-s-12 f-w-200">{{('Consent.Required' | trans)}}</div>
        <div class="f-s-13 f-w-700">
          @if (!consent.isRequired) {
            {{('General.No' | trans)}}
          }
          @if (consent.isRequired) {
            {{('General.Yes' | trans)}}
          }
        </div>
      </div>

      <div class="col-4 d-none d-md-block">
        <div class="f-s-12 f-w-200">{{('General.Link' | trans)}}</div>
        <div class="f-s-13 f-w-700">
          @if (consent.resource?.name && consent.resource?.type === 'PDF') {
            {{ consent.resource.name }}
          }
          @if (consent.resource?.link && consent.resource?.type === 'WEBSITE') {
            {{ consent.resource.link }}
          }
          @if (!consent.resource?.link) {
            -
          }
        </div>
      </div>
    </div>
  </div>

  <div class="card-menu">
    @for (menuItem of menuItems; track menuItem) {
      <div class="card-menu-item" [class.active]="activeMenuItem === menuItem.value"
        (click)="activeMenuItem = menuItem.value">
        {{(menuItem.label | trans)}}
      </div>
    }
  </div>

  <div class="card-menu-content">
    <div class="grid-content">
      @if (activeMenuItem === 'SETTINGS') {
        <div class="row">
          <div class="col-12 col-md-8">
            <div class="row">
              <div class="col-12">
                <div class="form-row">
                  <app-input-translation
                    formId="createEvent"
                    [(value)]="consent.name"
                    [type]="'text'"
                    [translation]="consent.nameTranslation"
                  [label]="('General.Name' | trans)"></app-input-translation>
                </div>
              </div>
            </div>
            <div class="row m-b-16">
              <div class="col-12">
                <div class="form-group">
                  <div class="form-row">
                    <div class="form-check">
                      <label class="checkbox">
                        <input type="checkbox" [checked]="consent.isRequired"
                          (change)="consent.isRequired = $event.target.checked"/>
                        <span class="label">{{('Consent.Required' | trans)}}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row form-group p-t-16">
              <div class="col-12">
                <app-form-radio formId="customer"
                  [(value)]="resourceType"
                  [options]="resourceTypes"
                  [optionLabelTranslate]="true"
                  (valueChange)="onResourceSelected(null)"
                  [listHorizontal]="true">
                </app-form-radio>
              </div>
            </div>
            @if (resourceType === 'WEBSITE') {
              <div class="row m-b-16">
                <div class="col-12">
                  <div class="form-row">
                    <app-form-input
                      [value]="consent.resource?.link"
                      [placeholder]="('General.Website' | trans)"
                    (change)="onResourceSelected(getMockResource($event.target.value, 'WEBSITE'), 'WEBSITE')"></app-form-input>
                  </div>
                </div>
              </div>
            }
            @if (resourceType === 'PDF') {
              <div class="row m-b-16">
                <div class="col-12">
                  <div class="form-row">
                    <app-file-picker
                      [label]="null"
                      [type]="'PDF'"
                      [file]="consent.resource"
                      [isRemoveAllowed]="true"
                      (fileSelected)="onResourceSelected($event, 'PDF')"
                    (fileRemoved)="onResourceSelected(null)"></app-file-picker>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      @if (activeMenuItem === 'CONDITIONS') {
        <p class="m-t-0">
          {{('Consent.Conditions_Intro' | trans)}}
        </p>
        <div class="conditions">
          @if (subscriptionTypes.length > 0) {
            <div class="row m-b-32">
              <div class="col-12 col-md-4">
                <span class="f-s-14">
                  {{('General.Subscription_Types' | trans)}}
                </span><br>
                <span class="header-link"
                  (click)="updateArraySelection('filterSubscriptionTypeIds', subscriptionTypes)">
                  {{('General.Select_All' | trans)}}
                </span> /
                <span class="header-link"
                  (click)="updateArraySelection('filterSubscriptionTypeIds', [])">
                  {{('General.Deselect_All' | trans)}}
                </span>
              </div>
              <div class="col-12 col-md-8">
                <div class="row">
                  @for (subscriptionType of subscriptionTypes; track subscriptionType) {
                    <div class="col-12 col-md-6">
                      <div class="form-check">
                        <label>
                          <input type="checkbox"
                            [checked]="inSelection('filterSubscriptionTypeIds', subscriptionType)"
                            (change)="updateSelection('filterSubscriptionTypeIds', subscriptionType)">
                          <span class="label">{{ subscriptionType.name }}</span>
                        </label>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          @if (events.length > 0) {
            <div class="row">
              <div class="col-12 col-md-4">
                <span class="f-s-14">
                  {{('General.Events' | trans)}}
                </span><br>
                <span class="header-link"
                  (click)="updateArraySelection('filterEventIds', events)">
                  {{('General.Select_All' | trans)}}
                </span> /
                <span class="header-link"
                  (click)="updateArraySelection('filterEventIds', [])">
                  {{('General.Deselect_All' | trans)}}
                </span>
              </div>
              <div class="col-12 col-md-8">
                <div class="row">
                  @for (event of events; track event) {
                    <div class="col-12 col-md-6">
                      <div class="form-check">
                        <label>
                          <input type="checkbox"
                            [checked]="inSelection('filterEventIds', event)"
                            (change)="updateSelection('filterEventIds', event)">
                          <span class="label">{{ event.name }}</span>
                        </label>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>

    <div class="row grid-footer">
      <div class="col-12 col-md-6">
        @if (consent.id) {
          <button class="btn btn-secondary btn-error" (click)="onDeleteConsentClicked()"
            >{{('General.Delete' | trans)}}
          </button>
        }

        @if (consent.id) {
          <button class="btn btn-secondary" [disabled]="!this.consent.consentSetting.filterSubscriptionTypeIds.length && !this.consent.consentSetting.filterEventIds.length"
          (click)="onClearConsentSettingClicked()">{{'Consent_Detail.Clear_Consent_Settings' | trans }}</button>
        }
      </div>
      <div class="col-12 col-md-6 text-right">
        <button class="btn btn-primary m-l-8" (click)="onSaveConsentClicked()">
          <span>{{('General.Save' | trans)}}</span>
        </button>
      </div>
    </div>
  </div>
</div>
